/* Bookly: Mobile Sticky Add To Cart (product page)
   - Shows a separate sticky bar at the bottom when the normal ATC button is out of view
   - Keeps the original ATC button in its normal position (next to quantity/Shop Pay)
   - Click on sticky button triggers the real product form submit
*/

(function () {
  // Touch detection so we don't show the mobile sticky on narrow desktop windows.
  var IS_TOUCH = false;
  try {
    IS_TOUCH = !!(window.matchMedia && window.matchMedia('(hover: none) and (pointer: coarse)').matches);
    document.documentElement.classList.toggle('bookly-touch', IS_TOUCH);
  } catch (e) {
    IS_TOUCH = false;
  }

  function isMobile() {
    return IS_TOUCH && window.matchMedia && window.matchMedia('(max-width: 767.98px)').matches;
  }

  function getHeaderOffset() {
    // Estimate fixed/sticky header height (incl. announcement bar if separate).
    // Used to trigger sticky ATC slightly earlier (when the original ATC starts
    // sliding under the header).
    var headerCandidates = [
      '.site-header',
      '.header',
      '#header',
      '.header-wrapper',
      '.header-area',
      'header'
    ];

    var headerEl = null;
    for (var i = 0; i < headerCandidates.length; i++) {
      headerEl = document.querySelector(headerCandidates[i]);
      if (headerEl) break;
    }

    var headerH = 0;
    if (headerEl && headerEl.getBoundingClientRect) {
      headerH = headerEl.getBoundingClientRect().height || 0;
    }

    // Some themes have a separate announcement bar above the header.
    var bar = document.querySelector('.announcement-bar, .top-bar, .header-top, .notification-bar');
    if (bar && bar.getBoundingClientRect && bar !== headerEl && !headerEl.contains(bar)) {
      headerH += (bar.getBoundingClientRect().height || 0);
    }

    // Hard caps to avoid weird values.
    headerH = Math.max(0, Math.min(200, headerH));
    return headerH;
  }

  function findPrimaryAtcButton() {
    // Prefer the main "Add to cart" submit button inside the product form.
    var form = document.querySelector('form[action^="/cart/add"]');
    if (!form) return null;

    // Try common selectors in this theme
    var btn = form.querySelector('button[type="submit"], input[type="submit"]');
    return btn || null;
  }

  function createSticky() {
    var sticky = document.createElement('div');
    sticky.className = 'bookly-sticky-atc';
    sticky.innerHTML = '<button type="button" class="bookly-sticky-atc__btn">Legg i handlekurv</button>';
    document.body.appendChild(sticky);
    return sticky;
  }

  function initOnce() {
    if (!document.body.classList.contains('template-product')) return;
    if (!isMobile()) return;
    if (document.querySelector('.bookly-sticky-atc')) return;

    var primaryBtn = findPrimaryAtcButton();
    if (!primaryBtn) return;

    // Trigger marker: use the buybox wrapper (qty + ATC area) so the sticky can
    // appear as soon as the *top* of the buybox hits the header.
    var markerEl = null;
    try {
      markerEl = primaryBtn.closest('.pro-details-quality') || primaryBtn;
    } catch (e) {
      // Fallback if closest isn't supported
      var p = primaryBtn;
      while (p && p !== document.body) {
        if (p.classList && p.classList.contains('pro-details-quality')) {
          markerEl = p;
          break;
        }
        p = p.parentNode;
      }
      markerEl = markerEl || primaryBtn;
    }

    var sticky = createSticky();
    var stickyBtn = sticky.querySelector('.bookly-sticky-atc__btn');

    function syncState() {
      try {
        // Mirror disabled state
        stickyBtn.disabled = !!primaryBtn.disabled;

        // Mirror label if possible
        var label = (primaryBtn.innerText || primaryBtn.value || '').trim();
        if (label) stickyBtn.textContent = label;
      } catch (e) {
        // no-op
      }
    }

    syncState();

    // Keep sticky label/state in sync when variant changes etc.
    if ('MutationObserver' in window) {
      var mo = new MutationObserver(function () {
        syncState();
      });
      mo.observe(primaryBtn, { attributes: true, childList: true, subtree: true, characterData: true });
    }

    // Make the sticky button respond even while the page is still "in motion"
    // from momentum scrolling (common on iOS). On some browsers, a tap during
    // inertia stops the scroll but does not fire a normal click.
    // We therefore trigger on touchstart / pointerdown for touch.
    var lastTriggerTs = 0;
    var lastTouchStartTs = 0;
    var keepVisibleUntil = 0;

    function stopMomentumScroll() {
      // Best-effort: cancel iOS momentum scroll so taps on fixed UI register immediately.
      try {
        var x = window.pageXOffset || 0;
        var y = window.pageYOffset || 0;
        window.scrollTo(x, y);
        window.requestAnimationFrame(function () {
          window.scrollTo(x, y);
        });
      } catch (e) {
        // no-op
      }
    }

    function triggerPrimary() {
      if (!primaryBtn || primaryBtn.disabled) return;
      primaryBtn.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
    }

    function fastTap(ev) {
      try {
        // Prevent the tap from being treated as "just stop scrolling".
        if (ev && ev.cancelable) ev.preventDefault();
      } catch (e) {
        // no-op
      }
      stopMomentumScroll();
      lastTriggerTs = Date.now();
      triggerPrimary();
    }

    stickyBtn.addEventListener('touchstart', function (ev) {
      lastTouchStartTs = Date.now();
      fastTap(ev);
    }, { passive: false, capture: true });

    stickyBtn.addEventListener('pointerdown', function (ev) {
      try {
        if (!ev || ev.pointerType !== 'touch') return;
        // Avoid double-fire on browsers that emit both touch and pointer events.
        if (Date.now() - lastTouchStartTs < 120) return;
        fastTap(ev);
      } catch (e) {
        // no-op
      }
    }, { passive: false, capture: true });

    // Fallback for non-touch click (should rarely run on mobile)
    stickyBtn.addEventListener('click', function () {
      if (Date.now() - lastTriggerTs < 800) return;
      triggerPrimary();
    });

    function showSticky() {
      sticky.classList.add('is-visible');
      document.body.classList.add('bookly-sticky-atc-visible');
      // Small hysteresis to prevent flicker around the threshold and make taps easier during inertia.
      keepVisibleUntil = Date.now() + 320;
    }

    function hideSticky(force) {
      if (!force && Date.now() < keepVisibleUntil) return;
      sticky.classList.remove('is-visible');
      document.body.classList.remove('bookly-sticky-atc-visible');
    }

    // Default hidden until we know the state
    hideSticky();

    // Show sticky when the original add-to-cart area starts sliding under the fixed header.
    // This makes the sticky ATC appear slightly earlier than waiting for the original
    // button to fully leave the viewport.
    var ticking = false;
    // Show the sticky *a bit before* the buybox top actually reaches the header.
    // User request: earlier than before, but not extreme.
    // Positive value means it appears earlier.
    var TRIGGER_EARLY_PX = 105;

    // Hide sticky when footer comes into view (so it doesn't cover footer CTAs).
    var footerEl = document.querySelector('footer, .site-footer, .footer, #footer, .footer-area');

    // Make the back-to-top arrow responsive during momentum scroll as well.
    // (ScrollUp plugin sometimes requires the scroll to fully stop before click registers.)
    function bindFastTapToScrollUp() {
      var el = document.getElementById('scrollUp');
      if (!el || el.__booklyFastTapBound) return;
      el.__booklyFastTapBound = true;

      var lastTs = 0;
      var lastTouchTs = 0;
      // Some mobile browsers (notably iOS Safari) can swallow the first tap during momentum scroll.
      // We therefore arm on touchstart and also fire on touchend/pointerup, and we "fight" inertia
      // by issuing a few scrollTo(0,0) calls over consecutive frames.
      var armed = false;

      function goTopHard() {
        try {
          window.scrollTo(0, 0);
        } catch (e) {
          // no-op
        }
        // Fight momentum/inertia: repeat a few times on following frames.
        try {
          window.requestAnimationFrame(function () { window.scrollTo(0, 0); });
          window.requestAnimationFrame(function () { window.scrollTo(0, 0); });
          window.requestAnimationFrame(function () { window.scrollTo(0, 0); });
        } catch (e2) {
          // no-op
        }
        try {
          setTimeout(function () { window.scrollTo(0, 0); }, 0);
          setTimeout(function () { window.scrollTo(0, 0); }, 60);
        } catch (e3) {
          // no-op
        }
      }

      function fast(ev) {
        try {
          if (ev && ev.cancelable) ev.preventDefault();
          if (ev && ev.stopPropagation) ev.stopPropagation();
        } catch (e) {
          // no-op
        }
        stopMomentumScroll();
        lastTs = Date.now();
        goTopHard();
      }

      el.addEventListener('touchstart', function (ev) {
        lastTouchTs = Date.now();
        armed = true;
        fast(ev);
      }, { passive: false, capture: true });

      // If the first tap during momentum only stops scrolling, touchend often still fires.
      // Use it as a backup so one tap is enough.
      el.addEventListener('touchend', function (ev) {
        if (!armed) return;
        if (Date.now() - lastTs < 250) return;
        fast(ev);
        armed = false;
      }, { passive: false, capture: true });

      el.addEventListener('pointerdown', function (ev) {
        try {
          if (!ev || ev.pointerType !== 'touch') return;
          if (Date.now() - lastTouchTs < 120) return;
          armed = true;
          fast(ev);
        } catch (e) {
          // no-op
        }
      }, { passive: false, capture: true });

      el.addEventListener('pointerup', function (ev) {
        try {
          if (!ev || ev.pointerType !== 'touch') return;
          if (!armed) return;
          if (Date.now() - lastTs < 250) return;
          fast(ev);
          armed = false;
        } catch (e) {
          // no-op
        }
      }, { passive: false, capture: true });

      // Always intercept click in capture so the plugin doesn't require a second tap.
      el.addEventListener('click', function (ev) {
        try {
          if (ev && ev.cancelable) ev.preventDefault();
          if (ev && ev.stopPropagation) ev.stopPropagation();
        } catch (e) {
          // no-op
        }
        // If touchstart didn't fire for some reason, click will be delayed until scroll stops.
        // Still ensure it works on a single interaction.
        if (Date.now() - lastTs > 120) {
          stopMomentumScroll();
          lastTs = Date.now();
          goTopHard();
        }
      }, true);
    }

    function updateStickyVisibility() {
      ticking = false;

      if (!isMobile()) {
        hideSticky(true);
        return;
      }

      var headerH = getHeaderOffset();
      var triggerLine = headerH + TRIGGER_EARLY_PX;

      var r = (markerEl && markerEl.getBoundingClientRect) ? markerEl.getBoundingClientRect() : primaryBtn.getBoundingClientRect();

      // Hide sticky when the footer is approaching.
      // We hide once the footer starts to enter the area where the sticky floats.
      if (footerEl && footerEl.getBoundingClientRect) {
        var fr = footerEl.getBoundingClientRect();
        if (fr.top <= window.innerHeight) {
          var stickyH = 0;
          try {
            stickyH = (sticky.getBoundingClientRect().height || 0);
          } catch (e) {
            stickyH = 0;
          }
          var hideLine = window.innerHeight - (stickyH + 16);
          if (fr.top < hideLine) {
            hideSticky(true);
            bindFastTapToScrollUp();
            return;
          }
        }
      }

      // Only show sticky after the user has reached (and then passed) the ATC area.
      // We treat "passed" as the buybox top moving into the header zone.
      if (r.top <= triggerLine) {
        showSticky();
      } else {
        hideSticky(false);
      }

      bindFastTapToScrollUp();
    }

    function requestUpdate() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(updateStickyVisibility);
    }

    window.addEventListener('scroll', requestUpdate, { passive: true });
    // Some mobile browsers can feel laggy with only scroll; touchmove helps keep it snappy.
    window.addEventListener('touchmove', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate);
    requestUpdate();

    // If the user rotates/resizes to desktop, hide sticky.
    window.addEventListener('resize', function () {
      if (!isMobile()) hideSticky(true);
      syncState();
    });
  }

  function boot() {
    initOnce();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
